const demo_app = {
    notification: 'Tipp: Erstelle zuerst ein Konto, um die Anmeldeerfahrung zu testen.',
};
export default demo_app;
